import {
  AllStateValues,
  IdCountry,
} from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllStateValues = (req: IdCountry): Promise<AllStateValues> => {
  return request({
    url: '/service/cbientityservice/GetAllStateValues',
    body: { ...req },
  }).then((r): AllStateValues => r.body);
};
